(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["gl_rich_text"] && !window.DesignMode) return;
  try {
    
// Removing plus button from foursixty app

 $(document).ready(function() {
var display =  jQuery(".fs-next-button").css("display");
    if(display!="none")
    {
        jQuery(".fs-next-button").attr("style", "display:none");
    }
});


  } catch(e) { console.error(e); }
})();

})();
